export default "__VITE_ASSET__Dz4IORXA__"